// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 135 ? "hlsjs" : chunkId) + "." + {"135":"b2935929","453":"de2dc535"}[chunkId] + ".chunk.js";
};